import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import RequestDemo from "./requestDemo";
import reportWebVitals from "./reportWebVitals";
// STARTS HERE
import * as AWS from "aws-sdk";

const configuration = {
  region: "ap-south-1",
  secretAccessKey: "uMI+bNg330zbV2AWDFMP7HZdSQiQz1g1aN4Fr5NL",
  accessKeyId: "AKIAUSFYTG6BZHWUO7WV",
};

AWS.config.update(configuration);
// ENDS HERE
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <RequestDemo />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
